import { ElTable, ElTableColumn } from 'element-plus';

const COMPAT_CONFIG = { MODE: 3 };

const internalComponents = ElTable.components as Record<string, unknown> | undefined;

const components = [
    ElTable,
    ElTableColumn,
    internalComponents?.TableHeader,
    internalComponents?.TableBody,
    internalComponents?.TableFooter,
    internalComponents?.ElScrollbar,
    internalComponents?.hColgroup,
];

for (const component of components) {
    if (component) {
        (component as Record<string, unknown>).compatConfig = COMPAT_CONFIG;
    }
}
